import { useTranslation } from 'react-i18next'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Divider, Modal } from 'antd'
import styled from 'styled-components'
import { Button } from '@lmc/ui-kit'
import { Heading, Text } from '@lmc/ui-kit/src/general'

type EnableGpsModalProps = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  isLoading?: boolean
}

function EnableGpsModal({
  open,
  onCancel,
  onConfirm,
  isLoading = false
}: EnableGpsModalProps) {
  const { t } = useTranslation()

  return (
    <StyledModal
      open={open}
      onCancel={onCancel}
      closable
      width={648}
      title={
        <ModalTitleWrapper>
          <ExclamationCircleOutlined
            style={{ color: '#fa8c16', fontSize: 22 }}
          />
          <ModalTitleText level={3}>
            {t('GEOFENCING_ENABLE_GPS_CONFIRM_TITLE')}
          </ModalTitleText>
        </ModalTitleWrapper>
      }
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t('CANCEL')}
        </Button>,
        <Button
          key="turn-on"
          variant="primary"
          onClick={onConfirm}
          isLoading={isLoading}
          style={{ marginLeft: '10px' }}
        >
          {t('GEOFENCING_TURN_ON')}
        </Button>
      ]}
    >
      <ModalBody>
        <Text level={1}>{t('GEOFENCING_ENABLE_GPS_CONFIRM_P1')}</Text>
        <Text level={1}>
          {t('GEOFENCING_ENABLE_GPS_CONFIRM_P2')}{' '}
          <strong>{t('GEOFENCING_ENABLE_GPS_CONFIRM_P2_BOLD')}</strong>
        </Text>
      </ModalBody>
      <Divider />
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }
  .ant-modal-title {
    text-transform: none;
  }
  .ant-modal-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
  }
`

const ModalTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const ModalTitleText = styled(Heading)`
  font-weight: 500;
  color: ${({ theme }) => theme.color?.neutral?.color3};
  text-transform: none;
`

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export default EnableGpsModal
